import React, { useEffect, useState } from "react";
import "./DeleteAccount.scss";
import { useTranslation } from "react-i18next";
import api from "../../../services/api";
import HeaderSimple from "../../components/HeaderSimple/HeaderSimple";

function Regulation() {
  const [text, setText] = useState({});
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    api
      .get("/text/delete-account")
      .then((response) => {
        setText(response.data);
      })
      .catch((error) => {
        console.error("Erro ao buscar dados do regulamento:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div className="loading">{t("loading")}</div>;
  }

  return (
    <>
      <HeaderSimple />
      <section className="regulation">
        <div className="container">
          <h2>{text.title}</h2>
          {text.description && <div dangerouslySetInnerHTML={{ __html: text.description }} />}
          {text.updated_at && (
            <span>
              {t("update-date")} {text.updated_at}
            </span>
          )}
        </div>
      </section>
    </>
  );
}

export default Regulation;
